// Getters
export const MY_SERVICES__PROPERTIES_WITH_GROUPED_SERVICES =
  'MY_SERVICES__PROPERTIES_WITH_GROUPED_SERVICES';
export const MY_SERVICES__SHOW_SHARE_WIDGET = 'MY_SERVICES__SHOW_SHARE_WIDGET';
